import { render } from "./unfinished.vue?vue&type=template&id=6e3b52d6&scoped=true"
const script = {}

import "./unfinished.vue?vue&type=style&index=0&id=6e3b52d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3b52d6"]])

export default __exports__